import { render, staticRenderFns } from "./AllocateModal.vue?vue&type=template&id=f96fc26c&"
import script from "./AllocateModal.vue?vue&type=script&lang=js&"
export * from "./AllocateModal.vue?vue&type=script&lang=js&"
import style0 from "./AllocateModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports